import { environment } from './../../../environments/environment';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { NgxMaskModule } from 'ngx-mask';
import { SolicitudOfertasComponent } from './solicitud-ofertas.component';
import { CommonModule } from '@angular/common';
import { ListadoProvinciaComponent } from './listado-provincia/listado-provincia.component';

@NgModule({
	declarations: [ SolicitudOfertasComponent, ListadoProvinciaComponent ],
	imports: [
		CommonModule,
		HttpClientModule,
		ReactiveFormsModule,
		RouterModule,
		RecaptchaV3Module,
		NgxMaskModule.forRoot()
	],
	providers: [ { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.googleApiKey } ],
	entryComponents: []
})
export class SolicitudOfertasModule {}
